import { render, staticRenderFns } from "./CustomTagInput.vue?vue&type=template&id=eff62dce&scoped=true&"
import script from "./CustomTagInput.vue?vue&type=script&lang=js&"
export * from "./CustomTagInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomTagInput.vue?vue&type=style&index=0&id=eff62dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff62dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eff62dce')) {
      api.createRecord('eff62dce', component.options)
    } else {
      api.reload('eff62dce', component.options)
    }
    module.hot.accept("./CustomTagInput.vue?vue&type=template&id=eff62dce&scoped=true&", function () {
      api.rerender('eff62dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/CustomTagInput.vue"
export default component.exports